import { render, staticRenderFns } from "./PopOver.vue?vue&type=template&id=2a476c12"
import script from "./PopOver.vue?vue&type=script&lang=js"
export * from "./PopOver.vue?vue&type=script&lang=js"
import style0 from "./PopOver.vue?vue&type=style&index=0&id=2a476c12&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports